import script from "./BuilderModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderModal.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderModal.vue?vue&type=style&index=0&id=23d183f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d183f5"]])

export default __exports__